module.exports = __webpack_public_path__ + "img/cogs.91836de5.svg";